export default function getElementProp(element, property) {
  return getComputedStyle(element).getPropertyValue(property);
}